/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { change_requests_ApprovalPreviewResponse } from '../models/change_requests_ApprovalPreviewResponse';
import type { change_requests_CareDayPlanResponse } from '../models/change_requests_CareDayPlanResponse';
import type { change_requests_CareDayProcessResponse } from '../models/change_requests_CareDayProcessResponse';
import type { change_requests_ChangeRequestInputDTO } from '../models/change_requests_ChangeRequestInputDTO';
import type { change_requests_ChildDataUpdatePlanResponse } from '../models/change_requests_ChildDataUpdatePlanResponse';
import type { change_requests_ChildDataUpdateProcessResponse } from '../models/change_requests_ChildDataUpdateProcessResponse';
import type { change_requests_CreateChangeRequestsRequest } from '../models/change_requests_CreateChangeRequestsRequest';
import type { change_requests_CreateChangeRequestsResponse } from '../models/change_requests_CreateChangeRequestsResponse';
import type { change_requests_InitiateChildDataUpdateRequest } from '../models/change_requests_InitiateChildDataUpdateRequest';
import type { change_requests_PausePlanResponse } from '../models/change_requests_PausePlanResponse';
import type { change_requests_PauseProcessResponse } from '../models/change_requests_PauseProcessResponse';
import type { change_requests_ResolveChangeRequestRequest } from '../models/change_requests_ResolveChangeRequestRequest';
import type { change_requests_ResolveChangeRequestResponse } from '../models/change_requests_ResolveChangeRequestResponse';
import type { models_WorkflowItem } from '../models/models_WorkflowItem';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChangeRequestsService {
    /**
     * Create change request(s)
     * Persists a producer-agnostic batch of structured change_requests (web_admin form, email→LLM, app forms). Each is routed by the shipped requires_approval policy: pending (approval required), approved+executed (auto-staged), manual (unhandled family, captured), or delegated_termination (terminate/cancel → contract-termination saga). N requests may share one source.message_id (decomposition). Also accepts the scoped machine (M2M) automation identity via the X-Automation-Auth header (#781); machine creates are attributed to the automation principal. Supply the optional client_capture_id to make the call idempotent: a repeat by the same user with the same key and body returns the first call's results with 200 and Idempotent-Replayed: true, and creates nothing; the same key with another body, or while the first call still runs, answers 409 IDEMPOTENCY_CONFLICT.
     * @param request Change request batch
     * @returns change_requests_CreateChangeRequestsResponse Replay of an earlier create with the same client_capture_id
     * @throws ApiError
     */
    public static postApiV1ChangeRequests(
        request: change_requests_CreateChangeRequestsRequest,
    ): CancelablePromise<change_requests_CreateChangeRequestsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests',
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `IDEMPOTENCY_CONFLICT`,
                422: `CHANGE_REQUEST_FAMILY_NOT_ALLOWED: the employee_data and time_correction families are filed only through /api/v1/employee/me/personal-data and /api/v1/employee/me/time-corrections`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Edit a pending change request in place (triage review)
     * Merges edited sub_type / resolution / executor body into a PENDING change_request's payload and stamps the server-authoritative review.edited marker. The item is not transitioned — the caller approves separately via the generic transition route, and the recorded outcome becomes `edited`. Only a pending item may be edited (409 otherwise).
     * @param id Change request workflow item ID
     * @param request Edited change request fields
     * @returns models_WorkflowItem OK
     * @throws ApiError
     */
    public static patchApiV1ChangeRequests(
        id: string,
        request: change_requests_ChangeRequestInputDTO,
    ): CancelablePromise<models_WorkflowItem> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/change-requests/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found, or an employee_data or time_correction request the caller may not see`,
                409: `Not pending, or an employee_data or time_correction request (never editable)`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Preview what approving a change request does
     * Dry-runs the approve of a change request without writing: the records it will create or change (actions), points that need attention (warnings) and problems that make the apply fail (blockers). Each line is a stable code with parameters for the review UI to translate. supported=false when the family has no preview.
     * @param id Workflow item ID
     * @returns change_requests_ApprovalPreviewResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangeRequestsApprovalPreview(
        id: string,
    ): CancelablePromise<change_requests_ApprovalPreviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/change-requests/{id}/approval-preview',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Billing-delta plan for a care_day change request
     * Read-only preview of a bounded care-day change: the [active_from, active_to] window, the add/remove weekday op, the current → proposed contracted weekdays, whether the change is a no-op, and the invoices the window will affect (period, status, reissue|cancel). No DB writes.
     * @param id Workflow item ID
     * @returns change_requests_CareDayPlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangeRequestsCareDayPlan(
        id: string,
    ): CancelablePromise<change_requests_CareDayPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/change-requests/care-day/{id}/plan',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Apply an approved care_day change request (recovery)
     * Recovery endpoint: applies the bounded weekday change (temporary auto-reverting contract version), adjusts group allocations best-effort, and regenerates the affected invoices, then fires the FSM execute/fail transition. The item must be in the approved state (409 otherwise). The normal path runs automatically on approval via the change_request router.
     * @param id Workflow item ID
     * @returns change_requests_CareDayProcessResponse OK
     * @throws ApiError
     */
    public static postApiV1ChangeRequestsCareDayProcess(
        id: string,
    ): CancelablePromise<change_requests_CareDayProcessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests/care-day/{id}/process',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Initiate a child_data_update change request
     * Creates a change_request workflow item (category change_request, family children) for a child-data / contact change targeting one or many children. Sensitive sub_types (allergy, medical, contact_pickup, contact_emergency) always create a pending item; a benign comment from a trusted source can auto-apply when the per-org auto-stage gate is on.
     *
     * Request contract (swag cannot model these conditional/oneOf constraints in the schema, so they are enforced in the handler and listed here): `child_ids` (1..200) and `sub_type` are always required, and `change` must carry the branch matching `sub_type` — only that branch is read (send just the matching branch). Required fields per sub_type: `comment` → `change.comment_value` (and optional `change.comment_field`, default `notes`); `allergy` → `change.allergy.operation`, plus `change.allergy.name` for `add` or `change.allergy.allergy_id` for `update`/`remove`; `medical` → `change.medical.kind` (disease|medication) and `change.medical.operation`, plus `change.medical.name` for `add` or `change.medical.id` for `update`/`remove`; `contact_pickup` / `contact_emergency` → `change.contact.contact_id` and `change.contact.grant` (grant must be explicitly present). A body that violates the matrix is rejected with 400.
     * @param request Change request intake
     * @returns models_WorkflowItem Created
     * @throws ApiError
     */
    public static postApiV1ChangeRequestsChildDataUpdate(
        request: change_requests_InitiateChildDataUpdateRequest,
    ): CancelablePromise<models_WorkflowItem> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests/child-data-update',
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Dry-run plan for a child_data_update change request
     * Read-only preview: resolved target child(ren), the proposed change, field-sensitivity, and whether approval is required. No DB writes.
     * @param id Workflow item ID
     * @returns change_requests_ChildDataUpdatePlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangeRequestsChildDataUpdatePlan(
        id: string,
    ): CancelablePromise<change_requests_ChildDataUpdatePlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/change-requests/child-data-update/{id}/plan',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Apply an approved child_data_update change request
     * Applies the field/contact change to the live records (single or bulk, with per-child outcomes on partial failure) and fires the FSM execute/fail transition. The item must be in the approved state (409 otherwise).
     * @param id Workflow item ID
     * @returns change_requests_ChildDataUpdateProcessResponse OK
     * @throws ApiError
     */
    public static postApiV1ChangeRequestsChildDataUpdateProcess(
        id: string,
    ): CancelablePromise<change_requests_ChildDataUpdateProcessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests/child-data-update/{id}/process',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Billing-delta plan for a pause change request
     * Read-only preview of a bounded contract pause: the [pause_from, pause_to] window, the create/extend/cancel sub-type, whether the change is a no-op, and the invoices the window (for extend, the union of old+new windows) will affect (period, status, reissue|cancel). No DB writes.
     * @param id Workflow item ID
     * @returns change_requests_PausePlanResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangeRequestsPausePlan(
        id: string,
    ): CancelablePromise<change_requests_PausePlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/change-requests/pause/{id}/plan',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Apply an approved pause change request (recovery)
     * Recovery endpoint: applies the bounded pause change (create/extend/cancel of a temporary auto-reverting zero-attendance contract version), adjusts group allocations best-effort, and regenerates the affected invoices, then fires the FSM execute/fail transition. The item must be in the approved state (409 otherwise). The normal path runs automatically on approval via the change_request router.
     * @param id Workflow item ID
     * @returns change_requests_PauseProcessResponse OK
     * @throws ApiError
     */
    public static postApiV1ChangeRequestsPauseProcess(
        id: string,
    ): CancelablePromise<change_requests_PauseProcessResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests/pause/{id}/process',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resolve extracted e-mail fields into change request candidates
     * Maps the fields an inbound parent e-mail was extracted into (child name, parent name, sender address, requested-change free text, dates) onto concrete children and contract groups WITHIN THE CALLER'S ORG, classifies the requested change into a family and sub_type with German and English keyword rules, and returns one ChangeRequestInputDTO-shaped candidate per classified family. Read-only: nothing is created. Confidence is calibrated from name similarity, an exact sender-address match on a linked contact, parent-name similarity, date plausibility against the contract window, and how far the best match beat the runner-up; an ambiguous or weak match leaves resolved.child_id empty and lists candidates instead, so the created item lands in the triage hand-holding bucket rather than being silently mis-resolved. Callable by admins of the org and by the scoped automation identity via the X-Automation-Auth header (#781).
     * @param request Extracted e-mail fields
     * @returns change_requests_ResolveChangeRequestResponse OK
     * @throws ApiError
     */
    public static postApiV1ChangeRequestsResolve(
        request: change_requests_ResolveChangeRequestRequest,
    ): CancelablePromise<change_requests_ResolveChangeRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/change-requests/resolve',
            body: request,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
